import { render, staticRenderFns } from "./CBProposalOtherInsurance.vue?vue&type=template&id=4795ad9c"
import script from "./CBProposalOtherInsurance.vue?vue&type=script&lang=js"
export * from "./CBProposalOtherInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports